var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScientist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.477 11.8903L11.9921 20.4165C12.009 20.5169 11.995 20.6201 11.9517 20.7123C11.9084 20.8045 11.8381 20.8813 11.75 20.9324C11.6619 20.9835 11.5604 21.0065 11.4589 20.9983C11.3574 20.9901 11.2608 20.9511 11.1821 20.8866L7.60194 18.1995C7.4291 18.0703 7.21915 18.0006 7.00342 18.0006C6.78768 18.0006 6.57773 18.0703 6.4049 18.1995L2.81878 20.8856C2.7401 20.95 2.64363 20.9889 2.54226 20.9971C2.44089 21.0053 2.33944 20.9824 2.25142 20.9314C2.16341 20.8805 2.09303 20.8039 2.04967 20.7119C2.00631 20.6199 1.99204 20.5169 2.00875 20.4165L3.5228 11.8903",
    stroke: "#01589B",
    strokeWidth: 2.00007,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0002 13.0004C10.314 13.0004 13.0004 10.314 13.0004 7.0002C13.0004 3.68638 10.314 1 7.0002 1C3.68638 1 1 3.68638 1 7.0002C1 10.314 3.68638 13.0004 7.0002 13.0004Z",
    stroke: "#01589B",
    strokeWidth: 2.00007,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientist);
export default __webpack_public_path__ + "static/media/scientist.07378ea50880654f212bde6622e1ff76.svg";
export { ForwardRef as ReactComponent };